import { breakpoints } from "./spacing";

type Breakpoints = typeof breakpoints;

type MediaQueries = {
  [K in keyof Breakpoints]: `@media (min-width: ${Breakpoints[K]}px)`;
};

const createMediaQuery = <T extends number>(width: T): `@media (min-width: ${T}px)` =>
  `@media (min-width: ${width}px)` as const;

export const mediaQueries: MediaQueries = {
  xs: createMediaQuery(breakpoints.xs),
  sm: createMediaQuery(breakpoints.sm),
  md: createMediaQuery(breakpoints.md),
  lg: createMediaQuery(breakpoints.lg),
  xl: createMediaQuery(breakpoints.xl),
  xxl: createMediaQuery(breakpoints.xxl),
};
